import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { orderStatuses } from '../../names';

export const CancelOrdersCount = ({orders}) => {

    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    });

    if (!isReady) {
        return null;
    }

    const ordersCount = orders.filter(o => o.orderStatus.name === orderStatuses.CANCEL).length;

    return createPortal(
        <div>
            отмен: <b>{ordersCount}</b>
        </div>,
        document.getElementById('cancel-count-root'),
    );
}
